export default {
  cookies: {
    title: 'Gizliliğinize saygı duyuyoruz',
    description:
      'Web sitemizin düzgün çalışmasını sağlamak, trafiği analiz etmek ve hizmetlerimizi geliştirmek için çerezleri kullanıyoruz. Çerezleri kabul edebilir veya reddedebilirsiniz. Seçiminizi daha sonra değiştirebilirsiniz.',
    accept: 'Tümünü kabul et',
    reject: 'Reddet',
    privacy_policy: 'Gizlilik Politikası'
  }
}
